import { useDeviceType } from '@vfit/shared/hooks';
import { organizeRateSummary } from './rateSummaryTable.oraganize';
import { ICountryRates } from './rateSummary.models';

export const useRateSummaryTable = (countryRate: ICountryRates) => {
  const data = organizeRateSummary(countryRate);

  const isDataEmpty = !data[0]?.title || !data[0]?.rates[0].title || !data[0]?.rates[0].value;

  const { isDesktop } = useDeviceType();

  return { data, isDataEmpty, isDesktop };
};
